// src/components/MomentWindowCard.jsx
import { Card, Box, Typography, Avatar } from "@mui/material";
import { motion } from "framer-motion";

// Time formatter
function timeAgo(timestamp) {
  const now = new Date();
  const t = new Date(timestamp);
  const diffMs = now - t;

  const minutes = Math.floor(diffMs / 60000);
  const hours = Math.floor(minutes / 60);

  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes} min ago`;
  return `${hours} hr ago`;
}

export default function MomentWindowCard({ data = {} }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
    >
      <Card
        sx={{
          p: 2.5,
          mb: 3,
          borderRadius: "20px",
          backgroundColor: "#FFFFFF",
          boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
          border: "1px solid #E5E7EB",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          
          {/* Avatars */}
          <Box sx={{ display: "flex", alignItems: "center", gap: -1 }}>
            <Avatar
              src={data.userAAvatar}
              sx={{ width: 46, height: 46, border: "2px solid #fff" }}
            />
            <Avatar
              src={data.userBAvatar}
              sx={{ width: 46, height: 46, border: "2px solid #fff" }}
            />
          </Box>

          {/* Text */}
          <Box>
            <Typography
              fontWeight={700}
              sx={{ fontSize: "16px", color: "#111827" }}
            >
              {data.userAName} & {data.userBName}
            </Typography>

            <Typography
              sx={{
                fontSize: "14px",
                color: "#4B5563",
                fontWeight: 500,
                mt: 0.2,
              }}
            >
              started a Quick Moment • {timeAgo(data.createdAt)}
            </Typography>
          </Box>
        </Box>
      </Card>
    </motion.div>
  );
}
